<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 个人设置
                </el-breadcrumb-item>
                <el-breadcrumb-item>修改密码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="form-box">
                <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item label="原密码" prop="password">
                        <el-input v-model="form.password" placeholder="原密码" type="password"  maxlength="18"></el-input>
                    </el-form-item>
					<el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="form.newPassword" placeholder="新密码" type="password"  maxlength="18"></el-input>
                    </el-form-item>
					<el-form-item label="确认密码" prop="newPasswordConfirm">
                        <el-input v-model="form.newPasswordConfirm" placeholder="确认密码" type="password"  maxlength="18"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" v-prevent-re-click>提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { userUpdatePassword } from '../../../api/index';
export default {
    name: 'set-password',
    data() {
		let validatePass = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
			} else if (value.toString().length < 6 || value.toString().length > 18) {
				callback(new Error('密码长度为6 - 18个字符'))
			} else {
				callback();
			}
		};
		let validatePass2 = (rule, value, callback) => {
			if (value === '') {
			callback(new Error('请再次输入密码'));
			} else if (value !== this.form.newPassword) {
			callback(new Error('两次输入密码不一致!'));
			} else {
			callback();
			}
		};
        return {
            form: {
				
            },
            rules: {
                password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
                newPassword: [{ required: true, validator:validatePass, trigger: 'blur' }],
				newPasswordConfirm: [{ required: true, validator: validatePass2, trigger: 'blur' }]
            },
			controll:{}
        };
    },
	created() {
		this.controll = getControll("set-password");
	},
    methods: {
        onSubmit() {
			this.$refs.form.validate(valid => {
				if (valid){
					userUpdatePassword(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('修改成功！');
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('密码信息填写不完整！');
				}
            });
        }
    }
};
</script>